
import { Toast, PullRefresh, Dialog } from "vant";
import { Component, Vue } from "vue-property-decorator";
import priceModal from "./priceModal.vue";
import NavBar from "@/components/navBar.vue";
import { sell, onshelf, downshelf, takeBack } from "@/req/user";
@Component({
  components: { PullRefresh, priceModal, NavBar },
})
export default class Logout extends Vue {
  public count = 0;
  public isLoading = false;
  public list = [];

  public mounted() {
    this.getList();
  }
  public async getList() {
    const obj: any = {
      page: 1,
      size: 20,
      type: "",
    };
    const res = await sell(obj);
    if (res.code == 200) {
      // 状态(-4取回失败， -3上架失败,-2:已失效，1:已上架，2:已下架，3:出售中   4:已出售，5:买家拒绝购买，6:上架中，7、取回中) '，
      this.list = res.data.data;
    }
  }
  public onClickLeft() {
    this.$router.go(-1);
  }
  public onRefresh() {
    this.getList();
    setTimeout(() => {
      Toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 1000);
  }
  public showPopup(item) {
    const $priceModal: any = this.$refs.priceModal;
    $priceModal.show(item);
  }
  public handleDelete(item) {
    Dialog.confirm({
      title: "是否删除该收藏",
    })
      .then(() => {
        this.deleteItem(item);
      })
      .catch(() => {
        // on cancel
      });
  }
  public deleteItem(item) {
    const obj = item;
  }
  // 显示弹窗 type 1 为上架  2 下架    3 取回
  public showDialog(type, item) {
    if (type == 3 && item.status == 1) {
      Toast("请先下架商品");
      return false;
    }
    Dialog.confirm({
      message:
        type == 1
          ? "是否重新上架该商品"
          : type == 2
          ? "是否下架该商品"
          : "商品取回后将在游戏中以邮件形式发送给您",
      //   message: "弹窗内容",
      confirmButtonText:
        type == 1 ? "上架商品" : type == 2 ? "确认" : "取回商品",
      confirmButtonColor: "#000",
    })
      .then(() => {
        // on confirm
        this.shelf(type, item);
      })
      .catch(() => {
        // on cancel
      });
  }
  // 上下架取回
  public async shelf(type, item) {
    const obj = {
      commodity_id: item.id,
    };
    let res;
    // type 1 为上架  2 下架    3 取回
    if (type == 1) {
      res = await onshelf(obj);
    } else if (type == 2) {
      res = await downshelf(obj);
    } else {
      res = await takeBack(obj);
    }
    Toast(res.msg);
    this.getList();
  }
  public toRoute(item) {
    if (item.status == 2) {
      Toast("该商品已下架");
      return false;
    }
    let status = true;
    if (
      item.status == 3 ||
      item.status == 4 ||
      item.status == 6 ||
      item.status == 7
    ) {
      status = false;
    }
    (this as any).$router.push({
      path: "/particulars",
      query: {
        id: item.id,
        type: item.type,
        footerStatus: status,
      },
    });
  }
}
